import { Constraint, Limit, Offer_Engagement_Type } from '@occc/graphql';

import { OfferType } from './types';

export type SupportedOfferValues = {
  engagementTypes: Offer_Engagement_Type[];
  constraints: Constraint['__typename'][];
  limits: Limit['__typename'][];
};

export const supportedOfferValues: SupportedOfferValues = {
  engagementTypes: [
    Offer_Engagement_Type.Promotional,
    Offer_Engagement_Type.Purchaseable,
    Offer_Engagement_Type.Transactional,
    Offer_Engagement_Type.PunchcardChallenge,
    Offer_Engagement_Type.Vouchered,
    Offer_Engagement_Type.SweepstakesEntry,
    Offer_Engagement_Type.SweepstakesPurchasable,
    Offer_Engagement_Type.SweepstakesTransactional,
    Offer_Engagement_Type.Behavioral,
    Offer_Engagement_Type.ExternallyFulfillable,
    Offer_Engagement_Type.StoredValue,
  ],
  constraints: [
    'ConstraintDaysOfWeek',
    'ConstraintInAudience',
    'ConstraintLocationInState',
    'ConstraintRequiresActivation',
    'ConstraintTimeOfDay',
    'ConstraintRequiresVoucher',
    'ConstraintStoreLocation',
    'ConstraintSubBrand',
  ],
  limits: [
    'LimitGlobalActivation',
    'LimitGlobalActivationInTime',
    'LimitGlobalAwardCount',
    'LimitGlobalAwardCountInTime',
    'LimitMembershipActivation',
    'LimitMembershipActivationInTime',
    'LimitMembershipAwardCount',
    'LimitMembershipAwardCountInTime',
  ],
};

export const engagementTypeToOfferTypeMap: { [key in Offer_Engagement_Type]?: OfferType } = {
  [Offer_Engagement_Type.Transactional]: OfferType.Offer,
  [Offer_Engagement_Type.Promotional]: OfferType.Promotion,
  [Offer_Engagement_Type.Purchaseable]: OfferType.Reward,
  [Offer_Engagement_Type.PunchcardChallenge]: OfferType.ClubOrPunchcard,
  [Offer_Engagement_Type.Vouchered]: OfferType.Award,
  [Offer_Engagement_Type.SweepstakesEntry]: OfferType.Award,
  [Offer_Engagement_Type.Billboard]: OfferType.Billboard,
  [Offer_Engagement_Type.Behavioral]: OfferType.LoyaltyEvent,
  [Offer_Engagement_Type.ExternallyFulfillable]: OfferType.ExternalFulfillment,
  [Offer_Engagement_Type.Game]: OfferType.FreeGame,
  [Offer_Engagement_Type.GameVoucher]: OfferType.VoucheredGame,
  [Offer_Engagement_Type.StoredValue]: OfferType.StoredValue,
};

export const offerTypeToEngagementTypeMap: { [key in OfferType]?: Offer_Engagement_Type } = {
  [OfferType.Offer]: Offer_Engagement_Type.Transactional,
  [OfferType.Challenge]: Offer_Engagement_Type.Transactional,
  [OfferType.Promotion]: Offer_Engagement_Type.Promotional,
  [OfferType.Reward]: Offer_Engagement_Type.Purchaseable,
  [OfferType.ClubOrPunchcard]: Offer_Engagement_Type.PunchcardChallenge,
  [OfferType.Award]: Offer_Engagement_Type.Vouchered,
  [OfferType.Billboard]: Offer_Engagement_Type.Billboard,
  [OfferType.LoyaltyEvent]: Offer_Engagement_Type.Behavioral,
  [OfferType.StoredValue]: Offer_Engagement_Type.StoredValue,
  [OfferType.ExternalFulfillment]: Offer_Engagement_Type.ExternallyFulfillable,
};

export const readonlyFundingSourceNames = ['Bybe'];
